export default `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
  <path d="M2170.99,2498h-1v8h1v-8Zm2,1.43v1.07a6.49,6.49,0,1,1-5,0v-1.06A7.5,7.5,0,1,0,2172.99,2499.43Z" transform="translate(-2163 -2498)"/>
</svg>`;
